import { z } from 'zod';
export enum ZoneTypeName {
  ROUTING = 'Ruteo',
  RATE = 'Tarifa',
}

export interface ZoneType {
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
}

export interface NewZoneType {
  name: string;
}

export interface UpdateZoneType {
  name?: string;
}

export const zoneTypeSchema = z.object({
  name: z
    .string()
    .min(1, 'El nombre es requerido')
    .max(50, 'El nombre no puede exceder 50 caracteres'),
});

export const updateZoneTypeSchema = zoneTypeSchema.partial();

export type ZoneTypeSchema = z.infer<typeof zoneTypeSchema>;
export type UpdateZoneTypeSchema = z.infer<typeof updateZoneTypeSchema>;

export const defaultZoneTypeValues: ZoneTypeSchema = {
  name: '',
};
